import React from 'react';

export function Cart({ color, size }) {
    return (
        <svg style={{ margin: 5 }} role="img" overflow="visible" aria-label="Cart" width={size ? size : "30"} viewBox="0 0 90 85" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 5L15 10L30 55H75L85 25" />
                <path d="M30 55L25 70H70" />
                <circle cx="25" cy="75" r="5" />
                <circle cx="70" cy="75" r="5" />
                <path id="cartL1" opacity="1" d="M30 25H85" />
                <path id="cartL2" opacity="1" d="M33 35H82" />
                <path id="cartL3" opacity="1" d="M36 45H79" />
            </g>
            <text className='cartText' x="35" y="45" style={{ fontSize: 0 }} fill={color}>0</text>
        </svg>
    )
}

export function GitHub({ size, theme }) {
    return (
        <svg height={size || "30"} viewBox='0 0 98 96' xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"
                fill={theme === "dark" ? "#24292f" : "white"}
            />
        </svg>
    )
}

export function Edit({ color, size }) {
    return (
        <svg style={{ margin: 5 }} role="img" overflow="visible" aria-label="Edit" width={size || "25"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M0 20L0 15L15 0C18 0, 20 2, 20 5L5 20Z" /> {/* Outer */}
                <path d="M2 15C4 15, 5 17, 5 18" /> {/* lower rim */}
                <path d="M14 3C16 3, 17 5, 17 6" /> {/* eraser rim */}
                <path d="M14 6L6 14" /> {/* middle line */}
                <path d="M0 20 L0 17C2 17, 3  18, 3 20Z" /> {/* tip */}
                <path d="M8 20 H17 C 19 20, 20 19,20 17V8" /> {/* border Bottom*/}
                <path d="M12 0 H3 C 1 0, 0 1,0 3V12" /> {/* border Top*/}
            </g>
        </svg>
    )
}

export function Done({ color, size }) {
    return (
        <svg role="img" overflow="visible" aria-label="Edit" width={size ? size : "25"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 0 H3 C 1 0, 0 1,0 3V7" /> {/* border Top*/}
                <path d="M0 15V17C 0 19, 1 20,3 20H4" /> {/* border Bottom Right*/}
                <path d="M11 20 H17 C 19 20, 20 19,20 17V8" /> {/* border Bottom Left*/}
                <path d="M0 10L7 19L19 3L7 15Z" /> {/* Check Mark */}
            </g>
        </svg>
    )
}

export function Cancel(props) {
    const { color, size } = props
    return (
        <svg role="img" overflow="visible" aria-label="Cancel" width={size ? size : "25"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 0 H3 C 1 0, 0 1,0 3V17C 0 19, 1 20,3 20H17 C 19 20, 20 19,20 17V3C 20 1, 19 0, 17 0" /> {/* border*/}
                <path d="M10 16 L15 11C18 8,13 2, 10 6L5 11" /> {/* arrow line*/}
                <path d="M5 6L5 11L10 11" /> {/* arrow line*/}
            </g>
        </svg>
    )
}

export function Add2Cart({ color, size }) {
    return (
        <svg style={{ margin: 5 }} role="img" overflow="visible" aria-label="Add to Cart" width={size ? size : "27"} viewBox="0 0 90 85" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 5L15 10L30 55H75L85 25" />
                <path d="M30 55L25 70H70" />
                <circle cx="25" cy="75" r="5" />
                <circle cx="70" cy="75" r="5" />
                <path d="M37 25H67" />
                <path d="M51 11V41" />
            </g>
        </svg>
    )
}

export function Info({ color, size }) {
    return (
        <svg style={{ margin: 5 }} width={size ? size : "25"} viewBox="0 0 100 100" strokeLinecap="round" stroke={color} fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="45" strokeWidth="5" />
            <circle cx="50" cy="25" r="5" fill={color} />
            <path d="M50 45V75" strokeWidth="8" />
        </svg>
    )
}

export function Add({ color, size }) {
    return (
        <svg style={{ margin: 5 }} width={size ? size : "20"} height={size ? size : "20"} viewBox="0 0 20 20" strokeLinecap="round" stroke={color} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 10H18" strokeWidth="2" />
            <path d="M10 2V18" strokeWidth="2" />
        </svg>
    )
}

export function AddS({ color, size }) {
    return (
        <svg role="img" overflow="visible" aria-label="Cancel" width={size ? size : "26"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 0 H3 C 1 0, 0 1,0 3V17C 0 19, 1 20,3 20H17 C 19 20, 20 19,20 17V3C 20 1, 19 0, 17 0" /> {/* border*/}
                <path d="M3 8 H8 V3 H12 V8 H17 V12 H12 V17 H8 V12 H3 Z" />
                {/* <path d="M10 4V16" /> */}
                {/* V9 H16V11 */}
            </g>
        </svg>
    )
}

export function RightArrow({ size, disabled }) {
    return (
        <svg style={{ margin: 5 }} width={size ? size : "25"} viewBox="0 0 12 20" strokeLinecap="round" strokeLinejoin="round" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d={disabled ? 'M6 2L 6 10 L6 18' : 'M2 2L 10 10 L2 18'} strokeWidth='2' />
        </svg>
    )
}

export function LeftArrow({ size, disabled }) {
    return (
        <svg style={{ margin: 5 }} width={size ? size : "25"} viewBox="0 0 12 20" strokeLinecap="round" strokeLinejoin="round" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d={disabled ? "M6 2L 6 10 L6 18" : "M10 2L 2 10 L10 18"} strokeWidth='2' />
        </svg>
    )
}

export function Exit({ size, color }) {
    return (
        <svg role="img" overflow="visible" aria-label="Edit" width={size ? size : "25"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 0 H3 C 1 0, 0 1,0 3V17C 0 19, 1 20,3 20H17 C 19 20, 20 19,20 17V3C 20 1, 19 0, 17 0" /> {/* border*/}
                <path d="M4 4L 16 16" strokeWidth='1' />
                <path d="M16 4L 4 16" strokeWidth='1' />
            </g>
        </svg>
    )
}

